import { getPrescriptions, IPrescription } from 'API';
import { useAppSelector } from 'Hooks';
import { createContext, FC, useEffect, useState } from 'react';

interface IPrescriptionContext {
  prescriptions: IPrescription[];
}

export const PrescriptionContext = createContext<IPrescriptionContext>({
  prescriptions: [],
});

interface IPrescriptionProvider {}

export const PrescriptionProvider: FC<IPrescriptionProvider> = (props) => {
  const [prescriptions, setPrescriptions] = useState<IPrescription[]>([]);
  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );
  const getAndSetPrescriptions = async () => {
    const prescriptions = await getPrescriptions();
    if (prescriptions) {
      setPrescriptions(prescriptions);
    }
  };

  useEffect(() => {
    getAndSetPrescriptions();
  }, [imposterId]);

  return (
    <PrescriptionContext.Provider
      value={{
        prescriptions,
      }}
    >
      {props.children}
    </PrescriptionContext.Provider>
  );
};
